<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 371.5 231.5" style="enable-background:new 0 0 371.5 231.5;" xml:space="preserve">
  <g>
    <defs>
      <rect id="SVGID_1_" y="69.7" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="SVGID_t5_2_">
      <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st0">
      <g>
        <defs>
          <path id="SVGID_3_" d="M0,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H9C4,161.8,0,157.8,0,152.8z"/>
        </defs>
        <clipPath id="SVGID_t5_4_">
          <use xlink:href="#SVGID_3_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st1">
          <path class="st2" d="M0,161.8V69.7h92.2v92.2H0z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="SVGID_5_" x="229.9" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="SVGID_t5_6_">
      <use xlink:href="#SVGID_5_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st3">
      <g>
        <defs>
          <path id="SVGID_7_" d="M229.9,83.2V9c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2C233.9,92.2,229.9,88.1,229.9,83.2z"
            />
        </defs>
        <clipPath id="SVGID_t5_8_">
          <use xlink:href="#SVGID_7_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st4">
          <path class="st2" d="M229.9,92.2V0h92.2v92.2H229.9z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="SVGID_9_" x="73.2" y="69.7" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="SVGID_t5_10_">
      <use xlink:href="#SVGID_9_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st5">
      <g>
        <defs>
          <path id="SVGID_11_" d="M73.2,152.8V78.7c0-5,4-9,9-9h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H82.2C77.2,161.8,73.2,157.8,73.2,152.8
            z"/>
        </defs>
        <clipPath id="SVGID_t5_12_">
          <use xlink:href="#SVGID_11_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st6">
          <path class="st2" d="M73.2,161.8V69.7h92.2v92.2H73.2z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="SVGID_13_" x="69.7" y="0" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="SVGID_t5_14_">
      <use xlink:href="#SVGID_13_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st7">
      <g>
        <defs>
          <path id="SVGID_15_" d="M78.7,0h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9V9C69.7,4,73.7,0,78.7,0z"/>
        </defs>
        <clipPath id="SVGID_t5_16_">
          <use xlink:href="#SVGID_15_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st8">
          <path class="st2" d="M69.7,0h92.2v92.2H69.7V0z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="SVGID_17_" x="69.7" y="139.4" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="SVGID_t5_18_">
      <use xlink:href="#SVGID_17_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st9">
      <g>
        <defs>
          <path id="SVGID_19_" d="M78.7,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9H78.7c-5,0-9-4-9-9v-74.2
            C69.7,143.4,73.7,139.4,78.7,139.4z"/>
        </defs>
        <clipPath id="SVGID_t5_20_">
          <use xlink:href="#SVGID_19_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st10">
          <path class="st2" d="M69.7,139.4h92.2v92.2H69.7V139.4z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="SVGID_21_" x="229.9" y="139.4" width="92.2" height="92.2"/>
    </defs>
    <clipPath id="SVGID_t5_22_">
      <use xlink:href="#SVGID_21_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st11">
      <g>
        <defs>
          <path id="SVGID_23_" d="M238.9,139.4h74.2c5,0,9,4,9,9v74.2c0,5-4,9-9,9h-74.2c-5,0-9-4-9-9v-74.2
            C229.9,143.4,233.9,139.4,238.9,139.4z"/>
        </defs>
        <clipPath id="SVGID_t5_24_">
          <use xlink:href="#SVGID_23_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st12">
          <path class="st2" d="M229.9,139.4h92.2v92.2h-92.2V139.4z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="SVGID_25_" x="16.3" y="16.3" width="355.3" height="199"/>
    </defs>
    <clipPath id="SVGID_t5_26_">
      <use xlink:href="#SVGID_25_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st13">
      <g>
        <defs>
          <path id="SVGID_27_" d="M39.3,16.3H348c6.1,0,11.9,2.4,16.3,6.7s6.7,10.2,6.7,16.3v153c0,6.1-2.4,11.9-6.7,16.3
            c-4.3,4.3-10.2,6.7-16.3,6.7H39.3c-6.1,0-11.9-2.4-16.3-6.7c-4.3-4.3-6.7-10.2-6.7-16.3v-153c0-6.1,2.4-12,6.7-16.3
            S33.2,16.3,39.3,16.3z"/>
        </defs>
        <clipPath id="SVGID_t5_28_">
          <use xlink:href="#SVGID_27_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st14">
          <path class="st15" d="M16.3,16.3h354.5v199H16.3V16.3z"/>
        </g>
      </g>
    </g>
  </g>
  <g>
    <defs>
      <rect id="SVGID_29_" x="117.9" y="40.1" width="151.4" height="151.4"/>
    </defs>
    <clipPath id="SVGID_t5_30_">
      <use xlink:href="#SVGID_29_"  style="overflow:visible;"/>
    </clipPath>
    <g class="st16">
      <g>
        <defs>
          <circle id="SVGID_31_" cx="193.6" cy="115.8" r="75.7"/>
        </defs>
        <clipPath id="SVGID_t5_32_">
          <use xlink:href="#SVGID_31_"  style="overflow:visible;"/>
        </clipPath>
        <g class="st17">
          <path class="st2" d="M117.9,40.1h151.4v151.4H117.9V40.1z"/>
        </g>
      </g>
    </g>
  </g>
  </svg>

</template>
<script>
export default {
  name: 't5'
}
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  }
  .st0{clip-path:url(#SVGID_t5_2_);}
  .st1{clip-path:url(#SVGID_t5_4_);}
  .st2{fill:#2C6EDF;}
  .st3{clip-path:url(#SVGID_t5_6_);}
  .st4{clip-path:url(#SVGID_t5_8_);}
  .st5{clip-path:url(#SVGID_t5_10_);}
  .st6{clip-path:url(#SVGID_t5_12_);}
  .st7{clip-path:url(#SVGID_t5_14_);}
  .st8{clip-path:url(#SVGID_t5_16_);}
  .st9{clip-path:url(#SVGID_t5_18_);}
  .st10{clip-path:url(#SVGID_t5_20_);}
  .st11{clip-path:url(#SVGID_t5_22_);}
  .st12{clip-path:url(#SVGID_t5_24_);}
  .st13{clip-path:url(#SVGID_t5_26_);}
  .st14{clip-path:url(#SVGID_t5_28_);}
  .st15{fill:#85B0F9;}
  .st16{clip-path:url(#SVGID_t5_30_);}
  .st17{clip-path:url(#SVGID_t5_32_);}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/t5.vue